import { takeEvery } from "redux-saga/effects";
import createRequestSaga from "../../common/saga/createRequestSaga";
import * as findPasswordApi from "../api/findPasswordApi";
import {
  SEND_FIND_PASSWORD_CODE,
  RESET_PASSWORD_BY_CODE
} from "../actionCreators";

const sendFindPasswordCode = createRequestSaga(
  SEND_FIND_PASSWORD_CODE,
  findPasswordApi.sendFindPasswordCodeApi
);
const resetPasswordByCode = createRequestSaga(
  RESET_PASSWORD_BY_CODE,
  findPasswordApi.resetPasswordByCodeApi
);

export function* findPasswordSaga() {
  yield takeEvery(SEND_FIND_PASSWORD_CODE, sendFindPasswordCode);
  yield takeEvery(RESET_PASSWORD_BY_CODE, resetPasswordByCode);
}
